module.exports = __webpack_public_path__ + "static/media/donor_recognition_wall--black.66195ebd.svg";